import type { useTranslations } from 'next-intl';

type TranslateFn = ReturnType<typeof useTranslations>;

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;

export function formatRelativeTime(
  timestamp: number,
  t: TranslateFn,
  now: number = Date.now(),
): string {
  const diff = now - timestamp;

  if (diff < MINUTE_MS) return t('get-feedback-relativeTime-justNow');
  if (diff < HOUR_MS) {
    return t('get-feedback-relativeTime-minutesAgo', {
      count: Math.floor(diff / MINUTE_MS),
    });
  }
  if (diff < DAY_MS) {
    return t('get-feedback-relativeTime-hoursAgo', {
      count: Math.floor(diff / HOUR_MS),
    });
  }
  if (diff < WEEK_MS) {
    return t('get-feedback-relativeTime-daysAgo', {
      count: Math.floor(diff / DAY_MS),
    });
  }

  return new Date(timestamp).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });
}

export function formatAbsoluteTime(timestamp: number): string {
  return new Date(timestamp).toLocaleString();
}
